import { ApiClient } from "@/api-client/src/core/api-client";
import { Product } from "@/packages/types/products";

const apiClient = new ApiClient();
const webService = apiClient.web;

export interface HomePageSectionData {
  id: number;
  sectionType: string;
  title: string;
  subtitle?: string;
  limit?: number;
  sliders?: {
    id: number;
    fileName?: string;
    mobileFileName?: string;
    navigationLink?: string;
    imageUrl?: string;
    mobileUrl?: string;
  }[];
  promoCard?: {
    id: number;
    fileName?: string;
    mobileFileName?: string;
    navigationLink?: string;
    imageUrl?: string;
    mobileUrl?: string;
  } | null;
  brands?: {
    id: number;
    name: string;
    slug: string;
    logoFileName?: string;
    logoUrl?: string;
    bannerFileName?: string;
    bannerUrl?: string;
  }[];
  categories?: {
    id: number;
    name: string;
    slug: string;
    imageFileName?: string;
    imageUrl?: string;
    bannerFileName?: string;
    bannerUrl?: string;
    products?: Product[];
  }[];
}

export interface HomePageResponse {
  status: string;
  message: string;
  data: {
    sections: HomePageSectionData[];
  };
}

export const fetchHomePageData = async (): Promise<HomePageResponse> => {
  const response = await webService.get<HomePageResponse>(`/home-page`);
  return response;
};

export interface HomePageMinimalSectionShell {
  id: number;
  sectionType: string;
  title: string;
  subtitle?: string;
  limit?: number;
  displayOrder?: number;
}


export interface HomePageMinimalResponse {
  status: string;
  message: string;
  data: {
    sections: HomePageMinimalSectionShell[];
  };
}

export interface HomePageSingleSectionResponse {
  status: string;
  message: string;
  data: HomePageSectionData;
}

export const fetchHomePageMinimalData = async (): Promise<HomePageMinimalResponse> => {
  const response = await webService.get<HomePageMinimalResponse>(`/home-page/minimal`);
  return response;
};

export const fetchHomePageSectionById = async (id: number): Promise<HomePageSingleSectionResponse> => {
  const response = await webService.get<HomePageSingleSectionResponse>(`/home-page/sections/${id}`);
  return response;
};

